<template>
  <div class="form__element"
      :class="{'form__element--inline': !!dialog}">
    <div class="form__checkbox"
         :class="{'form__checkbox--error': hasError}">
      <div class="form__checkbox-main-wrapper">
        <input :id="id + '-' + inputId"
               type="checkbox"
               :checked="modelValue"
               @change="handleChange"
               class="form__checkbox-field"
               :aria-invalid="hasError ? 'true' : null"
               :aria-describedby="hasError ? errorId : null" />
        <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="currentColor" viewBox="0 0 34 34" aria-hidden="true" focusable="false">
            <path fill-rule="evenodd" d="M24.528 11.436c.627.585.63 1.534.007 2.122l-9.546 9c-.3.283-.71.442-1.135.442-.426 0-.834-.16-1.135-.442L9.465 19.49a1.435 1.435 0 0 1 .007-2.121 1.676 1.676 0 0 1 2.263.006l2.119 1.998 8.411-7.93a1.676 1.676 0 0 1 2.263-.007Z" clip-rule="evenodd"></path>
          </svg>
        </span>
        <span class="form__label">
          <label class="label label--lg label--font-family-primary label--capitalize" :for="id + '-' + inputId">{{ label }}</label>
        </span>
      </div>
      <div :id="'helptext-' + id + '-' + inputId" class="form__checkbox-helptext">{{ helptext }}</div>
    </div>

    <div class="form__infos" v-if="!!dialog">
      <div class="form__infos-icon">
        <button class="btn btn--icon-sm btn--icon-only" aria-label="Öffnen Information über BIA-Messung" data-target="overlay" :data-target-id="'dialog-' + id + '-' + inputId" data-overlay-action="open" type="button">
          <span class="btn__icon">
            <span class="icon">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg" role="presentation">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11 2.2C6.13989 2.2 2.2 6.13989 2.2 11C2.2 15.8601 6.13989 19.8 11 19.8C15.8601 19.8 19.8 15.8601 19.8 11C19.8 6.13989 15.8601 2.2 11 2.2ZM0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM11 6.53125C10.2599 6.53125 9.625 7.14829 9.625 7.95299C9.625 8.56051 9.13251 9.05299 8.525 9.05299C7.91749 9.05299 7.425 8.56051 7.425 7.95299C7.425 5.97225 9.00627 4.33125 11 4.33125C12.9937 4.33125 14.575 5.97225 14.575 7.95299C14.575 9.55172 13.5449 10.9291 12.0991 11.401C12.099 11.6279 12.0989 11.8844 12.0989 12.1559C12.0989 12.7634 11.6064 13.2559 10.9989 13.2559C10.3914 13.2559 9.89892 12.7634 9.89892 12.1559C9.89892 11.6913 9.89919 11.2706 9.89946 10.9662L9.9 10.4737C9.90086 9.86683 10.3931 9.37474 11 9.37474C11.7401 9.37474 12.375 8.7577 12.375 7.95299C12.375 7.14829 11.7401 6.53125 11 6.53125ZM10.9989 14.85C11.6064 14.85 12.0989 15.3425 12.0989 15.95V15.9935C12.0989 16.601 11.6064 17.0935 10.9989 17.0935C10.3914 17.0935 9.89892 16.601 9.89892 15.9935V15.95C9.89892 15.3425 10.3914 14.85 10.9989 14.85Z"></path>
              </svg>
            </span>
          </span>
        </button>
      </div>
    </div>
    <Teleport to="body">
      <div v-if="!!dialog" class="overlay overlay--mobile-popup">
        <div class="overlay__inner" role="dialog" :id="'dialog-' + id + '-' + inputId" aria-modal="true" :aria-labelledby="'dialog-title-' + id + '-' + inputId">
          <div class="overlay__close-btn">
            <button class="sticky-nav-btn" :title="t('dialog.close')" data-target="overlay" data-overlay-action="close" :aria-label="t('dialog.close')">
            <span class="icon">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M16.0286 7.12381L12.1524 11L16.2381 15.0857L14.981 16.3429L14.7714 16.1333L10.8952 12.2571L6.80952 16.3429L5.55238 15.0857L9.6381 11L5.55238 6.91429L6.80952 5.65714L10.8952 9.74286L14.981 5.65714L16.2381 6.91429L16.0286 7.12381ZM22 11C22 17.0762 17.0762 22 11 22C4.92381 22 0 17.0762 0 11C0 4.92381 4.92381 0 11 0C17.0762 0 22 4.92381 22 11ZM20.5333 11C20.5333 5.76191 16.2381 1.46667 11 1.46667C5.76191 1.46667 1.46667 5.76191 1.46667 11C1.46667 16.2381 5.76191 20.5333 11 20.5333C16.2381 20.5333 20.5333 16.2381 20.5333 11Z"></path>
              </svg>
            </span>
              <span class="sticky-nav-btn__label">
              {{ t('dialog.close') }}
            </span>
            </button>
          </div>
          <div class="overlay__header" :id="'dialog-title-' + id + '-' + inputId">
            <div class="overlay__headline">
              <h2 class="headline headline--h5">
                {{ dialog.headline }}
              </h2>
            </div>
          </div>
          <div class="overlay__base">
            <p>
              {{ dialog.copy }}
            </p>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import {ref, watch, useId} from 'vue';
import {useI18n} from 'vue-i18n';
const { t } = useI18n();

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  hasError: {
    type: Boolean,
    default: false
  },
  errorId: {
    type: String
  },
  helptext: {
    type: String,
    default: ''
  },
  dialog: {
    type: Object,
    default: null
  },
  modelValue: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(['update:modelValue', 'validation-change']);

const internalValue = ref(props.modelValue);
const inputId = useId();

watch(() => props.modelValue, (newValue) => {
  internalValue.value = newValue;
});

const handleChange = (event) => {
  internalValue.value = event.target.checked;
  emit('update:modelValue', internalValue.value);
};
</script>